import { put, select, takeLatest, take } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import get from 'lodash/get';
import { CHANGE_PASSWORD_TYPES } from './constants';
import { PERSONAL_INFO } from '../../../constants/routes';
import { selectChangePasswordProcessFormData } from './selectors';
import deepTrim from '../../../utils/converters/deepTrim';
import * as editUser from '../../profiles/edit-user';
import * as usernameAvailability from '../signup/username-availability-req';
import { decodeQueryParams } from '../../../components/Auth/utils/decodeQueryParams';

function* handleChangePasswordProceed({ payload }) {
  const username = get(payload, 'username');

  yield put(
    usernameAvailability.actions.send({
      username: decodeQueryParams(username),
    }),
  );
  yield take(usernameAvailability.consts.SUCCEED);

  yield browserHistory.push(`/${PERSONAL_INFO}`);
}

function* handleConfirmChangePassword({ payload }) {
  const changePasswordFormData = yield select(
    selectChangePasswordProcessFormData,
  );
  const dataToSend = deepTrim({ ...changePasswordFormData, ...payload });
  yield put(editUser.actions.send(dataToSend));
}

export default function*() {
  yield takeLatest(CHANGE_PASSWORD_TYPES.PROCEED, handleChangePasswordProceed);
  yield takeLatest(CHANGE_PASSWORD_TYPES.CONFIRM, handleConfirmChangePassword);
}



// WEBPACK FOOTER //
// ./src/redux/auth/changePassword/change-password-saga.js